<template lang="pug">
  section#Contact

    SectionTitle(color="#F2E059" seo="04. Let's get in touch, m8")
      span(slot="number") 4
      span(slot="text1") Contact
      span(slot="text2") GET IN TOUCH

    blockquote(v-in-viewport.once="true") <strong>I aim to make web applications as modern and attractive as possible</strong>. I am looking forward to create digital products &amp; experiences for local and international brands, small or huge companies, and awesome human beings — like yourself! 👀

    //- mhm...
    //- ContactForm

    div.contact-me(v-in-viewport.once="true")
      .social
        p.contact-me_text(v-in-viewport.once="true") You can find me on the Internet
        SocialNetworks
      .intimate
        Revealer
          span(slot="text")  Let's work together™
          span.gradient(slot="text")  email@whoisjorge.me
</template>



<script>
  import ContactForm from '@/components/ContactForm.vue'

  export default {
    components: { ContactForm }
  }
</script>

<style lang="sass" scoped>
  #Contact

    blockquote
      color: #efefef
      text-align: left
      line-height: 1.3
      font-weight: 200
      font-size: calc(1.25rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
      margin: calc(2.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32)) 0
      opacity: 0

      &.in-viewport
        animation: .550s fadeIn 1250ms both

    .gradient
      background: linear-gradient(to right, #F55D07, #F3BF00)
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
      opacity: .5

    .contact-me
      // border: 1px solid transparent
      // border-image-source: linear-gradient(to right, #F55D07, #F3BF00)
      // border-image-slice: 10
      // outline: none
      // opacity: 0
      margin: 2rem 0 4rem 0
      padding: 1rem

      display: flex
      align-items: center
      justify-content: space-between
      flex-direction: column
      +breakpoint(lg)
        flex-direction: row

      &.in-viewport
        animation: 1.5s fadeIn 0ms both

      &_text
        display: block
        position: relative
        top: 50%
        left: 50%
        transform: translate3d(-50%,-50%,0)
        font-size: 1rem
        font-weight: 200
        padding: 1rem 0
        margin-top: 2rem
        text-align: center
        opacity: 0
        &.in-viewport
          animation: 1.5s fadeInDown 550ms both
        +breakpoint(md)
          font-size: 1.35rem


      .social
        p
          text-align: center
          +breakpoint(lg)
            text-align: left
      .intimate
        text-align: center
        +breakpoint(lg)
          text-align: right

      > *
        padding: .75rem 0
</style>



// WEBPACK FOOTER //
// src/components/sections/SectionContact.vue